// Status chip: IN STOCK (tactical olive) or PRE-ORDER (accent orange).
export default function StatusBadge({
  status = "IN_STOCK",
  label,
  size = "sm",
  className = "",
  ...rest
}) {
  const isPre = status === "PRE_ORDER";
  const bg = isPre ? "#FF9F1C" : "#4A5D3A";
  const fg = isPre ? "#0A0A0A" : "#FFFFFF";
  const displayLabel = label || (isPre ? "PRE-ORDER" : "IN STOCK");
  const sizeCls =
    size === "md" ? "text-[12px] px-3 py-1.5" : "text-[10px] px-2 py-1";
  return (
    <span
      className={
        "inline-flex items-center font-mono uppercase tracking-[0.06em] font-semibold " +
        sizeCls +
        " " +
        className
      }
      style={{ backgroundColor: bg, color: fg }}
      {...rest}
    >
      {displayLabel}
    </span>
  );
}
